export const Trim = (source: string) => source.replace(/^\s*|\s*$/g, '')
